/**
 * 엑셀 셀 값을 서버로 보낼 문자열로 읽는다.
 * 값이 없는(0/FALSE 포함) 셀은 기존과 같이 ''. 값이 있는 셀만 문자열로 바꾼다 —
 * xlsx 는 셀 타입을 유지하므로(숫자 2025, TRUE) 그대로 보내면 서버 문자열 검증에서 배치 전체가 400 이 된다.
 */
const cellText = (row, idx) => (row[idx] ? String(row[idx]) : '');

/**
 * 통계수집 칸만 예외: FALSE/0 은 "미수집" 값으로 보낸다(기존에는 || 'Y' 때문에 수집으로 뒤집혔다).
 * 그 외는 기존과 같다 — 빈 칸은 'Y'.
 */
const trackingText = (row, idx) => {
  const value = row[idx];
  if (value === false || value === 0) return String(value);
  return value ? String(value) : 'Y';
};

/**
 * sheet_to_json(sheet, { header: 1 }) 결과를 대량 등록 항목 배열로 바꾼다. 첫 행은 헤더.
 * 헤더 매칭·빈 행 판정·기본값은 기존 QrBulkUploadModal 파싱과 같다.
 */
export const toBulkQrItems = (jsonData) => {
  const [headers = [], ...rows] = jsonData;
  const column = (match) => headers.findIndex((h) => match(String(h)));

  const nameIdx = column((h) => h.includes('QR코드명') || h.toLowerCase() === 'name');
  const urlIdx = column((h) => h.includes('목적지') || h.toLowerCase().includes('url'));
  const descIdx = column((h) => h.includes('설명') || h.toLowerCase() === 'description');
  const catIdx = column((h) => h.includes('카테고리') || h.toLowerCase() === 'category');
  const tagIdx = column((h) => h.includes('태그') || h.toLowerCase() === 'tags');
  const statusIdx = column((h) => h.includes('상태') || h.toLowerCase() === 'status');
  const trackingIdx = column((h) => h.includes('통계') || h.toLowerCase() === 'tracking');

  return rows
    .filter((row) => row.some((cell) => cell))
    .map((row) => ({
      name: cellText(row, nameIdx),
      targetUrl: cellText(row, urlIdx),
      description: cellText(row, descIdx),
      category: cellText(row, catIdx),
      tags: cellText(row, tagIdx),
      status: cellText(row, statusIdx) || 'active',
      tracking: trackingIdx >= 0 ? trackingText(row, trackingIdx) : 'Y'
    }));
};
